import React from 'react';
import {List, Button, Popconfirm, Tag, Empty} from 'antd';
import {DeleteOutlined} from "@ant-design/icons";
import {getRoleLabel} from "../../utils/labelHelper";

const SYSTEM_ROLES = ['default-roles-amj-global', 'offline_access', 'uma_authorization'];

const UserRoles = ({roles, onRemove, isUpdating}) => {
    const displayRoles = roles.filter((role) => !SYSTEM_ROLES.includes(role.name));

    if (displayRoles.length === 0) {
        return <Empty description="No roles assigned" image={Empty.PRESENTED_IMAGE_SIMPLE}/>;
    }

    return (
        <List
            dataSource={displayRoles}
            renderItem={(role) => (
                <List.Item
                    actions={[
                        <Popconfirm
                            key="remove"
                            title={`Remove role "${getRoleLabel(role)}"?`}
                            onConfirm={() => onRemove(role.name)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button
                                type="text"
                                danger
                                icon={<DeleteOutlined/>}
                                loading={isUpdating}
                                size="small"
                            >
                                Remove
                            </Button>
                        </Popconfirm>
                    ]}
                >
                    <List.Item.Meta
                        title={<Tag color="blue">{getRoleLabel(role)}</Tag>}
                        description={<span style={{fontSize: 12, color: '#888'}}>{role.name}</span>}
                    />
                </List.Item>
            )}
        />
    );
};

export default UserRoles;
